import { render, staticRenderFns } from "./role_limit_table.vue?vue&type=template&id=0c611034&scoped=true&"
import script from "./role_limit_table.vue?vue&type=script&lang=js&"
export * from "./role_limit_table.vue?vue&type=script&lang=js&"
import style0 from "./role_limit_table.vue?vue&type=style&index=0&id=0c611034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c611034",
  null
  
)

export default component.exports